<template>
  <div class="contact-form">
    <label>{{ $t('root.filters.operator') }}</label>
    <select v-model='predicate'>
      <option :value='true'>{{ $t('root.filters.is') }}</option>
      <option :value='false'>{{ $t('root.filters.is_not') }}</option>
    </select>

    <label>{{ $t('root.filters.company_name') }}</label>
    <multi-select v-model='selectedCompanies' :getter='getContacts' :template="contactCompanyTemplate" />

    <div class="float-right">
      <button class="btn-sm btn btn-neutral m-r-10" @click.prevent="$emit('cancel')">{{ $t('root.filters.cancel') }}</button>
      <button class="btn-sm btn btn-primary" @click.prevent='filter'>{{ $t('root.filters.apply') }}</button>
    </div>
  </div>
</template>

<script>
import _multi_select from '../../shared/_infinite_multi_select'

export default {
  components: {
    'multi-select': _multi_select,
  },
  data() {
    return {
      predicate: true,
      selectedCompanies: [],
    }
  },
  computed: {
    selectedCompaniesIds() {
      return this.selectedCompanies.map(c => c.company)
    },
    predicateQuery() {
      return this.predicate ? 'filters[company_in]' : 'filters[company_not_in]'
    }
  },
  methods: {
    filter() {
      let newQuery = Object.assign({}, this.query)

      delete newQuery['filters[company_in]']
      delete newQuery['filters[company_not_in]']

      newQuery = Object.assign({}, newQuery, { page: 1, [this.predicateQuery]: this.selectedCompaniesIds })

      this.$router.push({ query: newQuery })
    },
    contactCompanyTemplate(c) {
      return c.company
    },
    getContacts(params) {
      let q = params.q
      let page = params.page
      return this.listStore.getContacts({ 'filters[company_blank]': false, 'filters[company_cont]': q, page: page })
    },
  }
}
</script>

<style lang="sass" scoped>
.contact-form
  width: 325px
  padding: 10px
  select
    margin-bottom: 15px
  .custom-select
    margin-bottom: 15px
.form-inline
  label
    margin-right: 10px
    &:first-child
      margin-right: 15px
  input
    margin-left: 3px
</style>
